const colours = {
    grey: '#6b6c6f',
    pink: '#F80093',
    lightPink: '#FBE8F4',
}

export default colours
